import Base from '../base'

export default {
  prepare: (cafeLink) => Base.get(`/reserve/${cafeLink}/prepare`),
  create: (data) => Base.post('/reserve/create', data),
  getPaymentLink: (reservationId) => Base.get(`/reservations/${reservationId}/payment-form`),
  getReservation: (reservationId) => Base.get(`/reservations/${reservationId}`),
  computeTimeslots: (data) => Base.post('/reserve/compute-timeslots', data)
}
